/*
 * VQ Back-in-Stock (Klaviyo)
 *
 * Inline-Anmeldung fuer ausverkaufte Varianten direkt auf der Produktseite —
 * kein Klaviyo-Popup. Schreibt per Client-API eine Back-in-Stock-Subscription,
 * die den Klaviyo-Flow "Wieder auf Lager" ausloest.
 *
 * API: POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=...
 * Variant-ID im Katalogformat: $shopify:::$default:::<shopify_variant_id>
 */
(function () {
  var KLAVIYO_BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var KLAVIYO_REVISION = '2025-07-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* Public API Key aus dem Klaviyo-Onsite-Script lesen, falls im Theme nicht gesetzt. */
  function detectCompanyId() {
    var scripts = document.querySelectorAll('script[src*="klaviyo.com/onsite/js/"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src') || '';
      var match = src.match(/[?&]company_id=([A-Za-z0-9]+)/) || src.match(/onsite\/js\/([A-Za-z0-9]+)\//);
      if (match) return match[1];
    }
    return '';
  }

  if (customElements.get('vq-back-in-stock')) return;

  customElements.define(
    'vq-back-in-stock',
    class VQBackInStock extends HTMLElement {
      connectedCallback() {
        this.companyId = this.dataset.companyId || detectCompanyId();
        this.variantId = this.dataset.variantId || '';
        this.buttonsWrapper = this.closest('.product-form__buttons');

        this.stepTrigger = this.querySelector('[data-bis-step="trigger"]');
        this.stepForm = this.querySelector('[data-bis-step="form"]');
        this.stepSuccess = this.querySelector('[data-bis-step="success"]');
        this.triggerBtn = this.querySelector('[data-bis-trigger]');
        this.input = this.querySelector('[data-bis-input]');
        this.submitBtn = this.querySelector('[data-bis-submit]');
        this.errorEl = this.querySelector('[data-bis-error]');
        this.submitLabel = this.submitBtn ? this.submitBtn.textContent : '';

        /* Ohne Public API Key kann nichts gesendet werden — dann lieber den
           normalen "Ausverkauft"-Button des Themes stehen lassen. */
        if (!this.companyId) {
          this.hidden = true;
          this.buttonsWrapper?.classList.remove('vq-bis-active');
          console.warn('[vq-back-in-stock] Kein Klaviyo Public API Key gefunden.');
          return;
        }

        this.triggerBtn?.addEventListener('click', this.openForm.bind(this));
        this.submitBtn?.addEventListener('click', this.subscribe.bind(this));
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.subscribe();
          }
        });
        this.input?.addEventListener('input', () => this.setError(''));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.onVariantChange(event?.data?.variant ?? null);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onVariantChange(variant) {
        var soldOut = !!variant && variant.available === false;

        if (variant && String(variant.id) !== String(this.variantId)) {
          this.variantId = String(variant.id);
          this.reset();
        }

        this.hidden = !soldOut;
        this.buttonsWrapper?.classList.toggle('vq-bis-active', soldOut);
      }

      reset() {
        this.setError('');
        if (this.input) this.input.value = '';
        this.showStep('trigger');
      }

      showStep(step) {
        if (this.stepTrigger) this.stepTrigger.hidden = step !== 'trigger';
        if (this.stepForm) this.stepForm.hidden = step !== 'form';
        if (this.stepSuccess) this.stepSuccess.hidden = step !== 'success';
      }

      openForm() {
        this.showStep('form');
        this.input?.focus();
      }

      setError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }

      setLoading(isLoading) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = isLoading;
        this.submitBtn.textContent = isLoading ? this.dataset.loadingLabel || '…' : this.submitLabel;
      }

      subscribe() {
        if (!this.input || this.submitBtn?.disabled) return;

        var email = this.input.value.trim();

        if (!EMAIL_PATTERN.test(email)) {
          this.setError(this.dataset.errorEmail || 'Bitte gib eine gültige E-Mail-Adresse ein.');
          this.input.focus();
          return;
        }

        this.setError('');
        this.setLoading(true);

        var bisPayload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + this.variantId,
                },
              },
            },
          },
        };

        this.klaviyoPost(KLAVIYO_BIS_ENDPOINT, bisPayload)
          .then(() => {
            /* Damit Klaviyo das Profil der laufenden Onsite-Session zuordnet. */
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
              window.klaviyo.identify({ email: email });
            }
            this.showStep('success');
          })
          .catch((error) => {
            console.error('[vq-back-in-stock]', error);
            this.setError(this.dataset.errorGeneric || 'Das hat leider nicht geklappt. Bitte versuche es erneut.');
          })
          .finally(() => this.setLoading(false));
      }

      klaviyoPost(endpoint, payload) {
        return fetch(endpoint + '?company_id=' + encodeURIComponent(this.companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: KLAVIYO_REVISION,
          },
          body: JSON.stringify(payload),
        }).then((response) => {
          if (!response.ok) throw new Error(endpoint + ' antwortete mit Status ' + response.status);
          return response;
        });
      }
    }
  );
})();
